module.exports = __webpack_public_path__ + "img/MG_4622-scaled.c68b655a.jpg";